module.exports = __webpack_public_path__ + "static/media/demo2.4e6a700d.jpg";